import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  TabActionDialog
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";

export const pageManageSection = "/pageManage";
export const pageEventSection = "/pageEvents";

export enum PageEventListUrlFiltersEnum {
  query = "query"
}

export enum PageEventListUrlFiltersWithMultipleValuesEnum {
  operateType = "operateType",
  languageCode = "languageCode"
}
export type PageEventListUrlFilters = Filters<PageEventListUrlFiltersEnum> &
  FiltersWithMultipleValues<PageEventListUrlFiltersWithMultipleValuesEnum>;

export type PageEventListUrlQueryParams = BulkAction &
  PageEventListUrlFilters &
  Pagination &
  Dialog<PageEventListUrlDialog> &
  ActiveTab;

export type PageEventListUrlDialog = TabActionDialog;

export const pageEventListUrl = (params?: PageEventListUrlQueryParams) =>
  pageEventSection + "?" + stringifyQs(params);
